var _assertThisInitialized = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e6) { throw _e6; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e7) { didErr = true; err = _e7; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (t) {
  "function" == typeof define && define.amd ? define(t) : t();
}(function () {
  "use strict";

  function t() {}

  var e = function e(t) {
    return t;
  };

  function n(t) {
    return t();
  }

  function o() {
    return Object.create(null);
  }

  function i(t) {
    t.forEach(n);
  }

  function r(t) {
    return "function" == typeof t;
  }

  function s(t, e) {
    return t != t ? e == e : t !== e || t && "object" == typeof t || "function" == typeof t;
  }

  function c(t, e) {
    return t != t ? e == e : t !== e;
  }

  function l(t) {
    return 0 === Object.keys(t).length;
  }

  var a = "undefined" != typeof window;
  var u = a ? function () {
    return window.performance.now();
  } : function () {
    return Date.now();
  },
      d = a ? function (t) {
    return requestAnimationFrame(t);
  } : t;
  var p = new Set();

  function h(t) {
    p.forEach(function (e) {
      e.c(t) || (p.delete(e), e.f());
    }), 0 !== p.size && d(h);
  }

  function f(t, e) {
    t.appendChild(e);
  }

  function m(t) {
    if (!t) return document;
    var e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
    return e && e.host ? e : t.ownerDocument;
  }

  function g(t, e) {
    f(t.head || t, e);
  }

  function y(t, e, n) {
    t.insertBefore(e, n || null);
  }

  function b(t) {
    t.parentNode.removeChild(t);
  }

  function w(t) {
    return document.createElement(t);
  }

  function v(t) {
    return document.createElementNS("http://www.w3.org/2000/svg", t);
  }

  function $(t) {
    return document.createTextNode(t);
  }

  function x() {
    return $(" ");
  }

  function k() {
    return $("");
  }

  function _(t, e, n, o) {
    return t.addEventListener(e, n, o), function () {
      return t.removeEventListener(e, n, o);
    };
  }

  function z(t, e, n) {
    null == n ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n);
  }

  function C(t, e, n, o) {
    t.style.setProperty(e, n, o ? "important" : "");
  }

  function E(t, e, n) {
    t.classList[n ? "add" : "remove"](e);
  }

  function S(t) {
    var e = {};

    var _iterator = _createForOfIteratorHelper(t),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _n = _step.value;
        e[_n.name] = _n.value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return e;
  }

  var N = new Set();
  var M,
      T = 0;

  function A(t, e, n, o, i, r, s) {
    var c = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    var l = 16.666 / o;
    var a = "{\n";

    for (var _t2 = 0; _t2 <= 1; _t2 += l) {
      var _o = e + (n - e) * r(_t2);

      a += 100 * _t2 + "%{".concat(s(_o, 1 - _o), "}\n");
    }

    var u = a + "100% {".concat(s(n, 1 - n), "}\n}"),
        d = "__svelte_".concat(function (t) {
      var e = 5381,
          n = t.length;

      for (; n--;) {
        e = (e << 5) - e ^ t.charCodeAt(n);
      }

      return e >>> 0;
    }(u), "_").concat(c),
        p = m(t);
    N.add(p);

    var h = p.__svelte_stylesheet || (p.__svelte_stylesheet = function (t) {
      var e = w("style");
      return g(m(t), e), e;
    }(t).sheet),
        f = p.__svelte_rules || (p.__svelte_rules = {});

    f[d] || (f[d] = !0, h.insertRule("@keyframes ".concat(d, " ").concat(u), h.cssRules.length));
    var y = t.style.animation || "";
    return t.style.animation = "".concat(y ? "".concat(y, ", ") : "").concat(d, " ").concat(o, "ms linear ").concat(i, "ms 1 both"), T += 1, d;
  }

  function L(t, e) {
    var n = (t.style.animation || "").split(", "),
        o = n.filter(e ? function (t) {
      return t.indexOf(e) < 0;
    } : function (t) {
      return -1 === t.indexOf("__svelte");
    }),
        i = n.length - o.length;
    i && (t.style.animation = o.join(", "), T -= i, T || d(function () {
      T || (N.forEach(function (t) {
        var e = t.__svelte_stylesheet;
        var n = e.cssRules.length;

        for (; n--;) {
          e.deleteRule(n);
        }

        t.__svelte_rules = {};
      }), N.clear());
    }));
  }

  function D(t) {
    M = t;
  }

  function I() {
    if (!M) throw new Error("Function called outside component initialization");
    return M;
  }

  var P = [],
      B = [],
      R = [],
      O = [],
      F = Promise.resolve();
  var H = !1;

  function V(t) {
    R.push(t);
  }

  var j = !1;
  var q = new Set();

  function U() {
    if (!j) {
      j = !0;

      do {
        for (var _t3 = 0; _t3 < P.length; _t3 += 1) {
          var _e = P[_t3];
          D(_e), G(_e.$$);
        }

        for (D(null), P.length = 0; B.length;) {
          B.pop()();
        }

        for (var _t4 = 0; _t4 < R.length; _t4 += 1) {
          var _e2 = R[_t4];
          q.has(_e2) || (q.add(_e2), _e2());
        }

        R.length = 0;
      } while (P.length);

      for (; O.length;) {
        O.pop()();
      }

      H = !1, j = !1, q.clear();
    }
  }

  function G(t) {
    if (null !== t.fragment) {
      t.update(), i(t.before_update);
      var _e3 = t.dirty;
      t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, _e3), t.after_update.forEach(V);
    }
  }

  var W;

  function J(t, e, n) {
    t.dispatchEvent(function (t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var o = document.createEvent("CustomEvent");
      return o.initCustomEvent(t, n, !1, e), o;
    }("".concat(e ? "intro" : "outro").concat(n)));
  }

  var K = new Set();
  var Q;

  function X() {
    Q = {
      r: 0,
      c: [],
      p: Q
    };
  }

  function Y() {
    Q.r || i(Q.c), Q = Q.p;
  }

  function Z(t, e) {
    t && t.i && (K.delete(t), t.i(e));
  }

  function tt(t, e, n, o) {
    if (t && t.o) {
      if (K.has(t)) return;
      K.add(t), Q.c.push(function () {
        K.delete(t), o && (n && t.d(1), o());
      }), t.o(e);
    }
  }

  var et = {
    duration: 0
  };

  function nt(n, o, s, c) {
    var l = o(n, s),
        a = c ? 0 : 1,
        f = null,
        m = null,
        g = null;

    function y() {
      g && L(n, g);
    }

    function b(t, e) {
      var n = t.b - a;
      return e *= Math.abs(n), {
        a: a,
        b: t.b,
        d: n,
        duration: e,
        start: t.start,
        end: t.start + e,
        group: t.group
      };
    }

    function w(o) {
      var _ref = l || et,
          _ref$delay = _ref.delay,
          r = _ref$delay === void 0 ? 0 : _ref$delay,
          _ref$duration = _ref.duration,
          s = _ref$duration === void 0 ? 300 : _ref$duration,
          _ref$easing = _ref.easing,
          c = _ref$easing === void 0 ? e : _ref$easing,
          _ref$tick = _ref.tick,
          w = _ref$tick === void 0 ? t : _ref$tick,
          v = _ref.css,
          $ = {
        start: u() + r,
        b: o
      };

      o || ($.group = Q, Q.r += 1), f || m ? m = $ : (v && (y(), g = A(n, a, o, s, r, c, v)), o && w(0, 1), f = b($, s), V(function () {
        return J(n, o, "start");
      }), function (t) {
        var e;
        0 === p.size && d(h), new Promise(function (n) {
          p.add(e = {
            c: t,
            f: n
          });
        });
      }(function (t) {
        if (m && t > m.start && (f = b(m, s), m = null, J(n, f.b, "start"), v && (y(), g = A(n, a, f.b, f.duration, 0, c, l.css))), f) if (t >= f.end) w(a = f.b, 1 - a), J(n, f.b, "end"), m || (f.b ? y() : --f.group.r || i(f.group.c)), f = null;else if (t >= f.start) {
          var _e4 = t - f.start;

          a = f.a + f.d * c(_e4 / f.duration), w(a, 1 - a);
        }
        return !(!f && !m);
      }));
    }

    return {
      run: function run(t) {
        r(l) ? (W || (W = Promise.resolve(), W.then(function () {
          W = null;
        })), W).then(function () {
          l = l(), w(t);
        }) : w(t);
      },
      end: function end() {
        y(), f = m = null;
      }
    };
  }

  var ot = "undefined" != typeof window ? window : "undefined" != typeof globalThis ? globalThis : global;

  function it(t, e, o, s) {
    var _t$$$ = t.$$,
        c = _t$$$.fragment,
        l = _t$$$.on_mount,
        a = _t$$$.on_destroy,
        u = _t$$$.after_update;
    c && c.m(e, o), s || V(function () {
      var e = l.map(n).filter(r);
      a ? a.push.apply(a, _toConsumableArray(e)) : i(e), t.$$.on_mount = [];
    }), u.forEach(V);
  }

  function rt(t, e) {
    var n = t.$$;
    null !== n.fragment && (i(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = []);
  }

  function st(t, e) {
    -1 === t.$$.dirty[0] && (P.push(t), H || (H = !0, F.then(U)), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
  }

  function ct(e, n, r, s, c, l, a) {
    var u = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [-1];
    var d = M;
    D(e);
    var p = e.$$ = {
      fragment: null,
      ctx: null,
      props: l,
      update: t,
      not_equal: c,
      bound: o(),
      on_mount: [],
      on_destroy: [],
      on_disconnect: [],
      before_update: [],
      after_update: [],
      context: new Map(n.context || (d ? d.$$.context : [])),
      callbacks: o(),
      dirty: u,
      skip_bound: !1,
      root: n.target || d.$$.root
    };
    a && a(p.root);
    var h = !1;

    if (p.ctx = r ? r(e, n.props || {}, function (t, n) {
      var i = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : n;
      return p.ctx && c(p.ctx[t], p.ctx[t] = i) && (!p.skip_bound && p.bound[t] && p.bound[t](i), h && st(e, t)), n;
    }) : [], p.update(), h = !0, i(p.before_update), p.fragment = !!s && s(p.ctx), n.target) {
      if (n.hydrate) {
        var _t5 = function (t) {
          return Array.from(t.childNodes);
        }(n.target);

        p.fragment && p.fragment.l(_t5), _t5.forEach(b);
      } else p.fragment && p.fragment.c();

      n.intro && Z(e.$$.fragment), it(e, n.target, n.anchor, n.customElement), U();
    }

    D(d);
  }

  var lt;
  "function" == typeof HTMLElement && (lt = /*#__PURE__*/function (_HTMLElement) {
    _inherits(lt, _HTMLElement);

    function lt() {
      var _this;

      _classCallCheck(this, lt);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(lt).call(this)), _this.attachShadow({
        mode: "open"
      });
      return _this;
    }

    _createClass(lt, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var t = this.$$.on_mount;
        this.$$.on_disconnect = t.map(n).filter(r);

        for (var _t6 in this.$$.slotted) {
          this.appendChild(this.$$.slotted[_t6]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(t, e, n) {
        this[t] = n;
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        i(this.$$.on_disconnect);
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        rt(this, 1), this.$destroy = t;
      }
    }, {
      key: "$on",
      value: function $on(t, e) {
        var n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
        return n.push(e), function () {
          var t = n.indexOf(e);
          -1 !== t && n.splice(t, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set(t) {
        this.$$set && !l(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
      }
    }]);

    return lt;
  }(_wrapNativeSuper(HTMLElement)));

  function at(t) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$delay = _ref2.delay,
        n = _ref2$delay === void 0 ? 0 : _ref2$delay,
        _ref2$duration = _ref2.duration,
        o = _ref2$duration === void 0 ? 400 : _ref2$duration,
        _ref2$easing = _ref2.easing,
        i = _ref2$easing === void 0 ? e : _ref2$easing;

    var r = +getComputedStyle(t).opacity;
    return {
      delay: n,
      duration: o,
      easing: i,
      css: function css(t) {
        return "opacity: " + t * r;
      }
    };
  }

  var ut, dt, pt, ht, ft, mt, gt;

  function yt(t) {
    !function (t, e, n) {
      var o = m(t);

      if (!o.getElementById(e)) {
        var _t7 = w("style");

        _t7.id = e, _t7.textContent = n, g(o, _t7);
      }
    }(t, "svelte-s2u2hd", ".Icon.svelte-s2u2hd{position:absolute;width:var(--icon-size);height:var(--icon-size);top:50%;left:50%;transform:translate(-50%, -50%);pointer-events:none;transition:0.25s;opacity:var(--icon-opacity)}");
  }

  function bt(t) {
    var e, n, o, i, r, s, _c, l, a, u, d, p, h;

    return {
      c: function c() {
        e = v("svg"), n = v("linearGradient"), o = v("animate"), i = v("animate"), r = v("stop"), s = v("stop"), _c = v("stop"), l = v("stop"), a = v("stop"), u = $(">\n  "), d = v("g"), p = v("path"), h = v("rect"), z(o, "attributeName", "y1"), z(o, "values", "-200%; 0%;"), z(o, "dur", "2s"), z(o, "repeatCount", "indefinite"), z(i, "attributeName", "y2"), z(i, "values", "200%; 400%;"), z(i, "dur", "2s"), z(i, "repeatCount", "indefinite"), z(r, "offset", "0%"), z(r, "stop-color", "var(--gradient-stop1)"), z(s, "offset", "25%"), z(s, "stop-color", "var(--gradient-stop2)"), z(_c, "offset", "50%"), z(_c, "stop-color", "var(--gradient-stop1)"), z(l, "offset", "75%"), z(l, "stop-color", "var(--gradient-stop2)"), z(a, "offset", "100%"), z(a, "stop-color", "var(--gradient-stop1)"), z(n, "id", "gradient"), z(n, "x1", "50%"), z(n, "y1", "-200%"), z(n, "x2", "50%"), z(n, "y2", "200%"), z(p, "d", "M42 26h4v4c0 9.265-7 16.895-16 17.89V55h-4v-7.11c-8.892-.982-15.833-8.444-15.997-17.56L10 30v-4h4v4c0 7.732 6.268 14 14 14 7.628 0 13.83-6.1 13.997-13.687L42 30v-4z"), z(h, "x", "20"), z(h, "y", "1"), z(h, "width", "16"), z(h, "height", "37"), z(h, "rx", "8"), z(d, "fill", "url(#gradient)"), z(d, "fill-rule", "evenodd"), z(e, "class", "Icon svelte-s2u2hd"), z(e, "viewBox", "0 0 56 56"), z(e, "xmlns", "http://www.w3.org/2000/svg");
      },
      m: function m(t, _m) {
        y(t, e, _m), f(e, n), f(n, o), f(n, i), f(n, r), f(n, s), f(n, _c), f(n, l), f(n, a), f(e, u), f(e, d), f(d, p), f(d, h);
      },
      d: function d(t) {
        t && b(e);
      }
    };
  }

  function wt(t) {
    var e, n, o, i;
    return {
      c: function c() {
        e = v("svg"), n = v("g"), o = v("path"), i = v("rect"), z(o, "d", "M42 26h4v4c0 9.265-7 16.895-16 17.89V55h-4v-7.11c-8.892-.982-15.833-8.444-15.997-17.56L10 30v-4h4v4c0 7.732 6.268 14 14 14 7.628 0 13.83-6.1 13.997-13.687L42 30v-4z"), z(i, "x", "20"), z(i, "y", "1"), z(i, "width", "16"), z(i, "height", "37"), z(i, "rx", "8"), z(n, "fill", "var(--icon-color)"), z(n, "fill-rule", "evenodd"), z(e, "class", "Icon svelte-s2u2hd"), z(e, "viewBox", "0 0 56 56"), z(e, "xmlns", "http://www.w3.org/2000/svg");
      },
      m: function m(t, r) {
        y(t, e, r), f(e, n), f(n, o), f(n, i);
      },
      d: function d(t) {
        t && b(e);
      }
    };
  }

  function vt(t) {
    var e, n, o, i;
    return {
      c: function c() {
        e = v("svg"), n = v("g"), o = v("path"), i = v("path"), z(o, "d", "M42 26h4v4c0 9.265-7 16.895-16 17.89V55h-4v-7.11c-8.892-.982-15.833-8.444-15.997-17.56L10 30v-4h4v4c0 7.732 6.268 14 14 14 7.628 0 13.83-6.1 13.997-13.687L42 30v-4z"), z(o, "fill-rule", "nonzero"), z(i, "d", "M37 13.081V31a8 8 0 11-16 0v-1.919l16-16zM26 1a8 8 0 018 8v1.319L18 26.318V9a8 8 0 018-8zM37.969 7.932l3.74-7.35 3.018 2.625zM39.654 10.608l7.531-3.359.695 3.94z"), z(n, "fill", "var(--icon-color)"), z(n, "fill-rule", "evenodd"), z(e, "class", "Icon svelte-s2u2hd"), z(e, "viewBox", "0 0 56 56"), z(e, "xmlns", "http://www.w3.org/2000/svg");
      },
      m: function m(t, r) {
        y(t, e, r), f(e, n), f(n, o), f(n, i);
      },
      d: function d(t) {
        t && b(e);
      }
    };
  }

  function $t(t) {
    var e, n, o, i;
    return {
      c: function c() {
        e = v("svg"), n = v("g"), o = v("path"), i = v("path"), z(o, "d", "M36 14.828V30a8 8 0 01-15.961.79l15.96-15.962zM28 1a8 8 0 018 8v.172L20 25.173V9a8 8 0 018-8z"), z(i, "d", "M42 26h4v4c0 9.265-7 16.895-16 17.89V55h-4v-7.11c-8.892-.982-15.833-8.444-15.997-17.56L10 30v-4h4v4c0 7.732 6.268 14 14 14 7.628 0 13.83-6.1 13.997-13.687L42 30v-4z"), z(n, "fill", "var(--icon-color)"), z(n, "fill-rule", "nonzero"), z(e, "class", "Icon svelte-s2u2hd"), z(e, "viewBox", "0 0 56 56"), z(e, "xmlns", "http://www.w3.org/2000/svg");
      },
      m: function m(t, r) {
        y(t, e, r), f(e, n), f(n, o), f(n, i);
      },
      d: function d(t) {
        t && b(e);
      }
    };
  }

  function xt(e) {
    var n,
        o,
        i,
        r,
        s = e[0] === ht.MicActive && bt(),
        _c2 = e[0] === ht.Mic && wt(),
        l = e[0] === ht.Error && vt(),
        a = e[0] === ht.Denied && $t();

    return {
      c: function c() {
        s && s.c(), n = x(), _c2 && _c2.c(), o = x(), l && l.c(), i = x(), a && a.c(), r = k();
      },
      m: function m(t, e) {
        s && s.m(t, e), y(t, n, e), _c2 && _c2.m(t, e), y(t, o, e), l && l.m(t, e), y(t, i, e), a && a.m(t, e), y(t, r, e);
      },
      p: function p(t, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            e = _ref4[0];

        t[0] === ht.MicActive ? s || (s = bt(), s.c(), s.m(n.parentNode, n)) : s && (s.d(1), s = null), t[0] === ht.Mic ? _c2 || (_c2 = wt(), _c2.c(), _c2.m(o.parentNode, o)) : _c2 && (_c2.d(1), _c2 = null), t[0] === ht.Error ? l || (l = vt(), l.c(), l.m(i.parentNode, i)) : l && (l.d(1), l = null), t[0] === ht.Denied ? a || (a = $t(), a.c(), a.m(r.parentNode, r)) : a && (a.d(1), a = null);
      },
      i: t,
      o: t,
      d: function d(t) {
        s && s.d(t), t && b(n), _c2 && _c2.d(t), t && b(o), l && l.d(t), t && b(i), a && a.d(t), t && b(r);
      }
    };
  }

  function kt(t, e, n) {
    var _e$icon = e.icon,
        o = _e$icon === void 0 ? ht.Mic : _e$icon;
    return t.$$set = function (t) {
      "icon" in t && n(0, o = t.icon);
    }, [o];
  }

  !function (t) {
    t[t.Failed = 0] = "Failed", t[t.NoBrowserSupport = 1] = "NoBrowserSupport", t[t.NoAudioConsent = 2] = "NoAudioConsent", t[t.__UnrecoverableErrors = 3] = "__UnrecoverableErrors", t[t.Disconnected = 4] = "Disconnected", t[t.Disconnecting = 5] = "Disconnecting", t[t.Connecting = 6] = "Connecting", t[t.Preinitialized = 7] = "Preinitialized", t[t.Initializing = 8] = "Initializing", t[t.Connected = 9] = "Connected", t[t.Stopping = 10] = "Stopping", t[t.Starting = 11] = "Starting", t[t.Recording = 12] = "Recording";
  }(ut || (ut = {})), function (t) {
    t.SpeechlyFirstConnect = "SpeechlyFirstConnect";
  }(dt || (dt = {})), function (t) {
    t.speechlypoweron = "speechlypoweron", t.holdstart = "holdstart", t.holdend = "holdend", t.speechstate = "speechstate", t.speechsegment = "speechsegment", t.speechhandled = "speechhandled", t.showhint = "showhint", t.transcriptdrawerhint = "hint", t.speechlyintroready = "speechlyintroready", t.speechlyintroclosed = "speechlyintroclosed";
  }(pt || (pt = {})), function (t) {
    t.Mic = "mic", t.MicActive = "micactive", t.Error = "error", t.Denied = "denied";
  }(ht || (ht = {})), function (t) {
    t.Hold = "hold", t.Click = "click", t.Noninteractive = "noninteractive";
  }(ft || (ft = {})), function (t) {
    t.None = "none", t.Connecting = "connecting", t.Busy = "busy";
  }(mt || (mt = {})), function (t) {
    t.None = "none", t.Whirl = "whirl";
  }(gt || (gt = {})), ut.Disconnected, ut.Disconnecting, ut.Connecting, ut.Preinitialized, ut.Initializing, ut.Connected, ut.Starting, ut.Recording, ut.Stopping, ut.Failed, ut.NoBrowserSupport, ut.NoAudioConsent;

  var _t = /*#__PURE__*/function (_ref5) {
    _inherits(_t, _ref5);

    function _t(t) {
      var _this2;

      _classCallCheck(this, _t);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(_t).call(this)), ct(_assertThisInitialized(_assertThisInitialized(_this2)), t, kt, xt, s, {
        icon: 0
      }, yt);
      return _this2;
    }

    return _t;
  }( /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);
    }

    _createClass(_class, [{
      key: "$destroy",
      value: function $destroy() {
        rt(this, 1), this.$destroy = t;
      }
    }, {
      key: "$on",
      value: function $on(t, e) {
        var n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
        return n.push(e), function () {
          var t = n.indexOf(e);
          -1 !== t && n.splice(t, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set(t) {
        this.$$set && !l(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
      }
    }]);

    return _class;
  }());

  var zt = ot.window;

  function Ct(t) {
    var e;
    return {
      c: function c() {
        e = w("link"), z(e, "href", "https://fonts.googleapis.com/css2?family=Saira+Condensed:wght@700&display=swap"), z(e, "rel", "stylesheet");
      },
      m: function m(t, n) {
        y(t, e, n);
      },
      d: function d(t) {
        t && b(e);
      }
    };
  }

  function Et(t) {
    var e;
    return {
      c: function c() {
        e = w("link"), z(e, "href", t[3]), z(e, "rel", "stylesheet");
      },
      m: function m(t, n) {
        y(t, e, n);
      },
      p: function p(t, n) {
        8 & n && z(e, "href", t[3]);
      },
      d: function d(t) {
        t && b(e);
      }
    };
  }

  function St(t) {
    var e, n, o, i, r, s, _c3, l, a, u, _d, p;

    var h = [Lt, At, Tt, Mt, Nt],
        _m2 = [];

    function g(t, e) {
      return t[4] === Rt || t[4] === ut.Initializing ? 0 : t[4] === Ot ? 1 : t[4] === ut.NoAudioConsent ? 2 : t[4] === ut.NoBrowserSupport ? 3 : 4;
    }

    return s = g(t), _c3 = _m2[s] = h[s](t), {
      c: function c() {
        e = w("modalbg"), o = x(), i = w("modalcontent"), r = w("main"), _c3.c(), l = x(), a = w("footer"), a.innerHTML = 'Voice input is automatically transcribed by <a target="_blank" href="https://speechly.com/" rel="noopener noreferrer">Speechly</a> and can be used to improve the quality of service under <a target="_blank" href="https://www.speechly.com/privacy/terms-and-conditions" rel="noopener noreferrer">terms of use</a>.', z(i, "class", t[1]), E(i, "defaultTypography", t[7]);
      },
      m: function m(n, c) {
        y(n, e, c), y(n, o, c), y(n, i, c), f(i, r), _m2[s].m(r, null), f(i, l), f(i, a), u = !0, _d || (p = _(e, "click", t[9]), _d = !0);
      },
      p: function p(t, e) {
        var n = s;
        s = g(t), s === n ? _m2[s].p(t, e) : (X(), tt(_m2[n], 1, 1, function () {
          _m2[n] = null;
        }), Y(), _c3 = _m2[s], _c3 ? _c3.p(t, e) : (_c3 = _m2[s] = h[s](t), _c3.c()), Z(_c3, 1), _c3.m(r, null)), (!u || 2 & e) && z(i, "class", t[1]), 130 & e && E(i, "defaultTypography", t[7]);
      },
      i: function i(o) {
        u || (V(function () {
          n || (n = nt(e, t[8], {
            duration: 200
          }, !0)), n.run(1);
        }), Z(_c3), u = !0);
      },
      o: function o(_o2) {
        n || (n = nt(e, t[8], {
          duration: 200
        }, !1)), n.run(0), tt(_c3), u = !1;
      },
      d: function d(t) {
        t && b(e), t && n && n.end(), t && b(o), t && b(i), _m2[s].d(), _d = !1, p();
      }
    };
  }

  function Nt(e) {
    var n, o, i, r, s, _c4, l, a;

    function u(t, e) {
      return t[2] ? It : Dt;
    }

    var d = u(e),
        _p = d(e);

    return {
      c: function c() {
        n = w("h2"), n.textContent = "Failed to connect to Speechly", o = x(), i = w("p"), _p.c(), r = x(), s = w("options"), _c4 = w("button"), _c4.textContent = "Ok, got it", z(_c4, "class", "button button-primary");
      },
      m: function m(t, u) {
        y(t, n, u), y(t, o, u), y(t, i, u), _p.m(i, null), y(t, r, u), y(t, s, u), f(s, _c4), l || (a = _(_c4, "click", e[9]), l = !0);
      },
      p: function p(t, e) {
        d === (d = u(t)) && _p ? _p.p(t, e) : (_p.d(1), _p = d(t), _p && (_p.c(), _p.m(i, null)));
      },
      i: t,
      o: t,
      d: function d(t) {
        t && b(n), t && b(o), t && b(i), _p.d(), t && b(r), t && b(s), l = !1, a();
      }
    };
  }

  function Mt(e) {
    var n, o, i, r, s, _c5, l, a;

    return {
      c: function c() {
        n = w("h2"), n.textContent = "Unsupported browser", o = x(), i = w("p"), i.textContent = "To use voice input, please visit this site using a supported browser.", r = x(), s = w("options"), _c5 = w("button"), _c5.textContent = "Ok, got it", z(_c5, "class", "button button-primary");
      },
      m: function m(t, u) {
        y(t, n, u), y(t, o, u), y(t, i, u), y(t, r, u), y(t, s, u), f(s, _c5), l || (a = _(_c5, "click", e[9]), l = !0);
      },
      p: t,
      i: t,
      o: t,
      d: function d(t) {
        t && b(n), t && b(o), t && b(i), t && b(r), t && b(s), l = !1, a();
      }
    };
  }

  function Tt(e) {
    var n, o, r, s, _c6, l, a, u, _d2, p;

    return {
      c: function c() {
        n = w("h2"), n.textContent = "Microphone blocked", o = x(), r = w("p"), r.textContent = "To use voice input, ".concat(window.location.hostname, " needs access to your microphone. Check your\n          browser preferences to allow microphone access and reload the page."), s = x(), _c6 = w("options"), l = w("button"), l.textContent = "Ok, got it", a = x(), u = w("button"), u.textContent = "Reload page", z(l, "class", "button button-secondary"), z(u, "class", "button button-primary");
      },
      m: function m(t, i) {
        y(t, n, i), y(t, o, i), y(t, r, i), y(t, s, i), y(t, _c6, i), f(_c6, l), f(_c6, a), f(_c6, u), _d2 || (p = [_(l, "click", e[9]), _(u, "click", e[18])], _d2 = !0);
      },
      p: t,
      i: t,
      o: t,
      d: function d(t) {
        t && b(n), t && b(o), t && b(r), t && b(s), t && b(_c6), _d2 = !1, i(p);
      }
    };
  }

  function At(e) {
    var n, o, r, s, _c7, l, a, u, _d3, p;

    return {
      c: function c() {
        n = w("h2"), n.textContent = "HTTPS required", o = x(), r = w("p"), r.textContent = "To use the voice interface, please visit this site using the secure\n          HTTPS protocol.", s = x(), _c7 = w("options"), l = w("button"), l.textContent = "Ok, got it", a = x(), u = w("button"), u.textContent = "Try with HTTPS", z(l, "class", "button button-secondary"), z(u, "class", "button button-primary");
      },
      m: function m(t, i) {
        y(t, n, i), y(t, o, i), y(t, r, i), y(t, s, i), y(t, _c7, i), f(_c7, l), f(_c7, a), f(_c7, u), _d3 || (p = [_(l, "click", e[9]), _(u, "click", e[13])], _d3 = !0);
      },
      p: t,
      i: t,
      o: t,
      d: function d(t) {
        t && b(n), t && b(o), t && b(r), t && b(s), t && b(_c7), _d3 = !1, i(p);
      }
    };
  }

  function Lt(t) {
    var e,
        n,
        o,
        i,
        r,
        s,
        _c8,
        l,
        a,
        u,
        _d4,
        p,
        h,
        _m3,
        g,
        v,
        k,
        E,
        S,
        N = window.location.hostname + "";

    _d4 = new _t({});
    var M = t[5] && Pt(t);
    return {
      c: function c() {
        var t;
        e = w("h2"), e.innerHTML = '<slot name="priming-title">Allow microphone</slot>', n = x(), o = w("p"), i = w("slot"), r = $("To use voice input, press "), s = w("strong"), s.textContent = "Allow", _c8 = $(" to give "), l = $(N), a = $(" access to your microphone.\n            Audio is only captured when "), u = w("span"), (t = _d4.$$.fragment) && t.c(), p = $(" button is pressed."), h = x(), _m3 = w("options"), g = w("button"), g.textContent = "Not now", v = x(), M && M.c(), C(u, "display", "inline-block"), C(u, "position", "relative"), C(u, "color", "white"), C(u, "width", "20px"), C(u, "height", "10px"), C(u, "--icon-color", "white"), C(u, "--icon-size", "20px"), z(i, "name", "priming-body"), z(g, "class", "button button-secondary");
      },
      m: function m(b, w) {
        y(b, e, w), y(b, n, w), y(b, o, w), f(o, i), f(i, r), f(i, s), f(i, _c8), f(i, l), f(i, a), f(i, u), it(_d4, u, null), f(i, p), y(b, h, w), y(b, _m3, w), f(_m3, g), f(_m3, v), M && M.m(_m3, null), k = !0, E || (S = _(g, "click", t[9]), E = !0);
      },
      p: function p(t, e) {
        t[5] ? M ? M.p(t, e) : (M = Pt(t), M.c(), M.m(_m3, null)) : M && (M.d(1), M = null);
      },
      i: function i(t) {
        k || (Z(_d4.$$.fragment, t), k = !0);
      },
      o: function o(t) {
        tt(_d4.$$.fragment, t), k = !1;
      },
      d: function d(t) {
        t && b(e), t && b(n), t && b(o), rt(_d4), t && b(h), t && b(_m3), M && M.d(), E = !1, S();
      }
    };
  }

  function Dt(e) {
    var n;
    return {
      c: function c() {
        n = $("Please check that your application has been successfully deployed.");
      },
      m: function m(t, e) {
        y(t, n, e);
      },
      p: t,
      d: function d(t) {
        t && b(n);
      }
    };
  }

  function It(t) {
    var e, n, o;
    return {
      c: function c() {
        e = $("Please check that your application (App ID: "), n = $(t[2]), o = $(") has been successfully deployed.");
      },
      m: function m(t, i) {
        y(t, e, i), y(t, n, i), y(t, o, i);
      },
      p: function p(t, e) {
        4 & e && function (t, e) {
          e = "" + e, t.wholeText !== e && (t.data = e);
        }(n, t[2]);
      },
      d: function d(t) {
        t && b(e), t && b(n), t && b(o);
      }
    };
  }

  function Pt(t) {
    var e, n, o, i, r;
    return {
      c: function c() {
        e = w("button"), n = $("Allow"), z(e, "class", "button button-primary"), e.disabled = o = t[4] === ut.Initializing;
      },
      m: function m(o, s) {
        y(o, e, s), f(e, n), i || (r = _(e, "click", t[10]), i = !0);
      },
      p: function p(t, n) {
        16 & n && o !== (o = t[4] === ut.Initializing) && (e.disabled = o);
      },
      d: function d(t) {
        t && b(e), i = !1, r();
      }
    };
  }

  function Bt(e) {
    var n,
        o,
        r,
        s,
        c,
        l,
        a,
        u = e[7] && Ct(),
        _d5 = void 0 !== e[3] && Et(e),
        _p2 = e[6] && St(e);

    return {
      c: function c() {
        u && u.c(), n = k(), o = x(), _d5 && _d5.c(), r = x(), s = w("modal"), _p2 && _p2.c(), this.c = t, C(s, "--remsize", e[0]);
      },
      m: function m(t, i) {
        u && u.m(document.head, null), f(document.head, n), y(t, o, i), _d5 && _d5.m(t, i), y(t, r, i), y(t, s, i), _p2 && _p2.m(s, null), c = !0, l || (a = [_(zt, "keydown", e[11]), _(zt, "message", e[12])], l = !0);
      },
      p: function p(t, _ref6) {
        var _ref7 = _slicedToArray(_ref6, 1),
            e = _ref7[0];

        t[7] ? u || (u = Ct(), u.c(), u.m(n.parentNode, n)) : u && (u.d(1), u = null), void 0 !== t[3] ? _d5 ? _d5.p(t, e) : (_d5 = Et(t), _d5.c(), _d5.m(r.parentNode, r)) : _d5 && (_d5.d(1), _d5 = null), t[6] ? _p2 ? (_p2.p(t, e), 64 & e && Z(_p2, 1)) : (_p2 = St(t), _p2.c(), Z(_p2, 1), _p2.m(s, null)) : _p2 && (X(), tt(_p2, 1, 1, function () {
          _p2 = null;
        }), Y()), (!c || 1 & e) && C(s, "--remsize", t[0]);
      },
      i: function i(t) {
        c || (Z(_p2), c = !0);
      },
      o: function o(t) {
        tt(_p2), c = !1;
      },
      d: function d(t) {
        u && u.d(t), b(n), t && b(o), _d5 && _d5.d(t), t && b(r), t && b(s), _p2 && _p2.d(), l = !1, i(a);
      }
    };
  }

  var Rt = "PagePriming",
      Ot = "HttpsRequired";

  function Ft(t, e, n) {
    var o,
        i,
        _e$hide = e.hide,
        r = _e$hide === void 0 ? "auto" : _e$hide,
        s = e.clientstate,
        _e$remsize = e.remsize,
        c = _e$remsize === void 0 ? "1.0rem" : _e$remsize,
        _e$position = e.position,
        l = _e$position === void 0 ? "fixed" : _e$position,
        a = e.appid,
        u = e.customcssurl,
        d = e.customtypography,
        p = !0;

    var h = function () {
      var t = I();
      return function (e, n) {
        t.dispatchEvent(new CustomEvent(e, {
          detail: n,
          composed: !0
        }));
      };
    }(),
        f = (m = at, function (t, e) {
      if (!t.hasOwnProperty("ownerDocument")) {
        Object.defineProperty(t, "ownerDocument", {
          get: function get() {
            return t.parentElement;
          }
        });
        var _e5 = t;

        for (; _e5.parentElement;) {
          _e5 = _e5.parentElement;
        }

        t.parentElement.head = _e5;
      }

      return m(t, e);
    });

    var m;
    var g = !1,
        y = Rt,
        b = null,
        w = !1;
    var v;
    v = function v() {
      n(17, g = !0), window.postMessage({
        type: pt.speechlyintroready
      }, "*");
    }, I().$$.on_mount.push(v);

    var $ = function $() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      n(6, o = !1), h("speechlyintroclosed", t), window.postMessage(Object.assign({
        type: pt.speechlyintroclosed
      }, t), "*");
    },
        x = function x(t) {
      var e, i;
      ("auto" === r && n(6, o = !0), b && (window.clearTimeout(b), b = null), "https:" === (null === (e = null === window || void 0 === window ? void 0 : window.location) || void 0 === e ? void 0 : e.protocol) || "localhost" === (i = window.location.hostname) || "[::1]" === i || null !== i.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)) ? n(4, y = t) : n(4, y = Ot);
    },
        k = function k(t) {
      switch (t) {
        case ut.Initializing:
          y === Rt ? (n(4, y = t), b = window.setTimeout(function () {
            b = null, "auto" === r && n(6, o = !0);
          }, 500)) : n(6, o = !0);
          break;

        case ut.Connected:
          p && (p = !1, b ? (window.clearTimeout(b), b = null, $()) : $({
            firstrun: !0
          }));
          break;

        case ut.Failed:
        case ut.NoAudioConsent:
        case ut.NoBrowserSupport:
          x(t);
      }
    };

    return t.$$set = function (t) {
      "hide" in t && n(14, r = t.hide), "clientstate" in t && n(15, s = t.clientstate), "remsize" in t && n(0, c = t.remsize), "position" in t && n(1, l = t.position), "appid" in t && n(2, a = t.appid), "customcssurl" in t && n(3, u = t.customcssurl), "customtypography" in t && n(16, d = t.customtypography);
    }, t.$$.update = function () {
      32768 & t.$$.dirty && s && k(parseInt(s)), 147456 & t.$$.dirty && n(6, o = g && "false" === r), 65536 & t.$$.dirty && n(7, i = void 0 === d || "false" === d);
    }, [c, l, a, u, y, w, o, i, f, $, function () {
      window.SpeechlyClient.initialize();
    }, function (t) {
      g && "Escape" === t.key && (t.preventDefault(), $());
    }, function (t) {
      switch (t.data.type) {
        case pt.speechlypoweron:
          "auto" === r && n(6, o = !0), n(5, w = !0);
          break;

        case pt.speechstate:
          k(t.data.state);
          break;

        case pt.holdstart:
          switch (t.data.state) {
            case ut.Failed:
            case ut.NoAudioConsent:
            case ut.NoBrowserSupport:
              x(t.data.state);
          }

      }
    }, function () {
      var t = window.location.href.replace("http:", "https:");
      window.location.replace(t);
    }, r, s, d, g, function () {
      window.location.reload();
    }];
  }

  var Ht = /*#__PURE__*/function (_lt) {
    _inherits(Ht, _lt);

    function Ht(t) {
      var _this3;

      _classCallCheck(this, Ht);

      _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Ht).call(this)), _this3.shadowRoot.innerHTML = "<style>modal{font-size:var(--remsize);pointer-events:none;height:100%}modalbg{position:fixed;top:0;bottom:0;left:0;right:0;overflow:hidden;z-index:2000;pointer-events:auto;background-color:rgba(0,0,0,0.75);backdrop-filter:blur(3px)}modalcontent{z-index:2001;pointer-events:auto;box-sizing:border-box;width:100%;min-height:100%;padding:1.5rem;display:flex;flex-direction:column;align-items:center;justify-content:center;color:#fff}modalcontent.fixed{position:fixed;top:0;left:0;right:0;bottom:0;overflow-x:hidden;overflow-y:auto}modalcontent.absolute{position:absolute;top:0;left:0;right:0;height:100vh}.defaultTypography{font-family:-apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;color:#fff;font-size:1rem;line-height:1.5}.defaultTypography h2{font-family:'Saira Condensed', sans-serif;padding:0;margin:0;text-transform:uppercase;color:#fff;font-size:1.5rem;line-height:1.25}main{position:relative;box-sizing:border-box;width:100%;max-width:400px;margin:auto 0;padding:1.5rem 0}options{display:flex;margin-top:2rem;gap:8px}.button{background-color:transparent;box-sizing:border-box;border:1px solid transparent;border-radius:999px;cursor:pointer;font-family:inherit;font-size:1rem;font-weight:600;line-height:1.25;min-width:7rem;padding:0.5rem 1.5rem;transition:all 0.15s ease;white-space:nowrap;-webkit-tap-highlight-color:transparent}.button[disabled],.button:disabled{cursor:auto;opacity:0.5;pointer-events:none}.button-secondary{border-color:#fff;color:#fff}.button-secondary:hover{border-color:#ccc;color:#ccc}.button-primary{background-color:#fff;border-color:#fff;color:#000}.button-primary:hover{border-color:#ccc;background-color:#ccc;color:#000}footer{box-sizing:border-box;font-size:0.75rem;color:#999;margin:0}a,a:visited{color:#999;transition:all 0.15s ease;-webkit-tap-highlight-color:transparent}a:hover{color:#ccc}</style>", ct(_assertThisInitialized(_assertThisInitialized(_this3)), {
        target: _this3.shadowRoot,
        props: S(_this3.attributes),
        customElement: !0
      }, Ft, Bt, c, {
        hide: 14,
        clientstate: 15,
        remsize: 0,
        position: 1,
        appid: 2,
        customcssurl: 3,
        customtypography: 16
      }, null), t && (t.target && y(t.target, _assertThisInitialized(_assertThisInitialized(_this3)), t.anchor), t.props && (_this3.$set(t.props), U()));
      return _this3;
    }

    _createClass(Ht, [{
      key: "hide",
      get: function get() {
        return this.$$.ctx[14];
      },
      set: function set(t) {
        this.$$set({
          hide: t
        }), U();
      }
    }, {
      key: "clientstate",
      get: function get() {
        return this.$$.ctx[15];
      },
      set: function set(t) {
        this.$$set({
          clientstate: t
        }), U();
      }
    }, {
      key: "remsize",
      get: function get() {
        return this.$$.ctx[0];
      },
      set: function set(t) {
        this.$$set({
          remsize: t
        }), U();
      }
    }, {
      key: "position",
      get: function get() {
        return this.$$.ctx[1];
      },
      set: function set(t) {
        this.$$set({
          position: t
        }), U();
      }
    }, {
      key: "appid",
      get: function get() {
        return this.$$.ctx[2];
      },
      set: function set(t) {
        this.$$set({
          appid: t
        }), U();
      }
    }, {
      key: "customcssurl",
      get: function get() {
        return this.$$.ctx[3];
      },
      set: function set(t) {
        this.$$set({
          customcssurl: t
        }), U();
      }
    }, {
      key: "customtypography",
      get: function get() {
        return this.$$.ctx[16];
      },
      set: function set(t) {
        this.$$set({
          customtypography: t
        }), U();
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ["hide", "clientstate", "remsize", "position", "appid", "customcssurl", "customtypography"];
      }
    }]);

    return Ht;
  }(lt);

  customElements.get("intro-popup") ? console.warn("Skipping re-defining customElement intro-popup") : customElements.define("intro-popup", Ht);
});